<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Promo</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-select class="ml-2 mr-2" v-model="input.filterStatusPromo" id="filterInput" name="statusPromo" :options="statusPromo" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih filter status --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-input class="mr-2"
                            v-model="input.filterNamaPromo" name="filterNamaPromo"
                            type="search"
                            placeholder="Nama Promo"
                            @keyup.enter="onFilter" 
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="promoAddBtn" @click="inputPromo">Input Promo</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="promos" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data promo.
                </template>
                <template v-slot:cell(name)="row">
                    <p class="mb-0">{{row.item.name}}</p>
                    <div class="mb-0 smallText text-muted no-wrap">
                        {{$helper.changeDateFormat(row.item.start)}} -  
                        {{$helper.changeDateFormat(row.item.end)}}
                    </div>
                    <p class="mb-0 smallText text-muted">
                        {{row.item.jumlahCabang}} cabang
                    </p>
                </template>
                <template v-slot:cell(pinjaman)="row">
                    <div v-if="row.item.jenisBarang.name != null && row.item.merk.name != null && row.item.tipe.name != null">
                        <p class="mb-0">{{row.item.tipe.name}}</p>
                        <p class="mb-0 smallText text-muted">
                            {{row.item.jenisPinjaman.name}} -
                            {{row.item.jenisBarang.name}} -
                            {{row.item.merk.name}}
                        </p>
                        <div class="mb-0 smallText text-muted no-wrap">
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMinimal)}} -  
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMaksimal)}}
                        </div>
                    </div>
                    <div v-else-if="row.item.jenisBarang.name != null && row.item.merk.name != null">
                        <p class="mb-0">{{row.item.merk.name}}</p>
                        <p class="mb-0 smallText text-muted">
                            {{row.item.jenisPinjaman.name}} -
                            {{row.item.jenisBarang.name}}
                        </p>
                        <div class="mb-0 smallText text-muted no-wrap">
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMinimal)}} -  
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMaksimal)}}
                        </div>
                    </div>
                    <div v-else-if="row.item.jenisBarang.name != null">
                        <p class="mb-0">{{row.item.jenisBarang.name}}</p>
                        <p class="mb-0 smallText text-muted">
                            {{row.item.jenisPinjaman.name}}
                        </p>
                        <div class="mb-0 smallText text-muted no-wrap">
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMinimal)}} -  
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMaksimal)}}
                        </div>
                    </div>
                    <div v-else>
                        <p class="mb-0">{{row.item.jenisPinjaman.name}}</p>
                        <div class="mb-0 smallText text-muted no-wrap">
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMinimal)}} -  
                            Rp. {{$helper.addThousandSeparator(row.item.hargaBarangMaksimal)}}
                        </div>
                    </div>
                </template>
                <template v-slot:cell(nominal)="row">
                    <div class="text-right no wrap" v-if="row.item.nominal == null">{{$helper.addThousandSeparator(row.item.nominal)}} </div>
                    <div class="text-right no wrap text-danger" v-else-if="row.item.nominal < 0">Rp. {{$helper.addThousandSeparator(row.item.nominal)}} </div>
                    <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominal)}} </div>
                </template>
                <template v-slot:cell(persen)="row">
                    <div class="text-right no-wrap" v-if="row.item.persen == null">{{$helper.addThousandSeparator(row.item.persen)}} </div>
                    <div class="text-right no-wrap text-danger" v-else-if="row.item.persen < 0 ">{{$helper.addThousandSeparator(row.item.persen)}} %</div>
                    <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.persen)}} %</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="primary" v-if="row.item.status == 1">BERJALAN</b-badge>
                    <b-badge variant="warning" v-else-if="row.item.status == 2">SELESAI</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 0">PENDING</b-badge>
                    <b-badge v-else>UNKNOWN</b-badge>   
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-3 table-button view" v-b-tooltip.hover title="Detail" name="promoViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                        <b-link :to="`${$route.path}/${row.item.id}/edit`">
                            <b-button size="sm" class="table-button edit" v-b-tooltip.hover title="Edit" name="promoEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Promo ini sudah disiapkan, namun belum berjalan karena masih diluar periode promo.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BERJALAN</h6>
                <p class="smallText mb-0">Promo ini sedang berjalan dan dapat digunakan saat melakukan penggadaian.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">SELESAI</h6>
                <p class="smallText mb-0">Promo ini sudah selesai dan tidak dapat digunakan lagi saat melakukan penggadaian.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'master-promo',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterNamaPromo: null,
                filterStatusPromo: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "name", label: "Nama Promo", sortable:true },
                { key: "pinjaman", label: "Pinjaman" },
                { key: "nominal", label: "Nominal Angka", sortable: true},
                { key: "persen", label: "Nominal Persen", sortable: true},
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            statusPromo: [
                { id: 0, name: 'Pending'},
                { id: 1, name: 'Berjalan'},
                { id: 2, name: 'Selesai'},
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            promos: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getPromo = this.$axios.get("promo/"+this.query).then(response => {
                this.promos = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getPromo]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Ambil Data Promo -----------------

        getPromo(){
            this.toggleBusy()
            this.promos = []

            if(this.input.filterStatusPromo != null) this.query = this.query + "&filterStatus=" + this.input.filterStatusPromo
            if(this.input.filterNamaPromo != null) this.query = this.query + "&filterName=" + this.input.filterNamaPromo
            if(this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if(this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get("promo/"+this.query).then(response => {
                this.promos = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getPromo()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getPromo()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy == "persen"){
                this.input.sortBy = "nominalPersen"
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }else if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterStatusPromo = null
            this.input.filterNamaPromo = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getPromo()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getPromo()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputPromo(){
            this.$router.push({path: `${this.$route.path}/input`});
        }
    },

    created(){
        this.init()
    }
}
</script>
